import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.show,
      "title": _vm.titulo,
      "size": "xl",
      "centered": "",
      "hide-footer": ""
    },
    on: {
      "hidden": function hidden($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.salvar.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome da rotina"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.state('nome'),
      "placeholder": "Envio mensal ao contador"
    },
    model: {
      value: _vm.form.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nome", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.nome"
    }
  }), _c('b-form-invalid-feedback', [_vm._v(_vm._s(_vm.errors.nome))])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.ativo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ativo", $$v);
      },
      expression: "form.ativo"
    }
  }, [_vm._v(" Ativo ")])], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('EmailListInput', {
    attrs: {
      "label": "Destinatários",
      "error": _vm.errors.emails
    },
    model: {
      value: _vm.form.emails,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "emails", $$v);
      },
      expression: "form.emails"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('EmailListInput', {
    attrs: {
      "label": "Cópia",
      "placeholder": "financeiro@example.com",
      "error": _vm.errors.cc
    },
    model: {
      value: _vm.form.cc,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cc", $$v);
      },
      expression: "form.cc"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('EmailListInput', {
    attrs: {
      "label": "Cópia oculta",
      "placeholder": "gestao@example.com",
      "error": _vm.errors.bcc
    },
    model: {
      value: _vm.form.bcc,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bcc", $$v);
      },
      expression: "form.bcc"
    }
  })], 1)], 1), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Dia do mês"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "31",
      "state": _vm.state('dia_mes')
    },
    model: {
      value: _vm.form.dia_mes,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dia_mes", _vm._n($$v));
      },
      expression: "form.dia_mes"
    }
  }), _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.errors.dia_mes) + " ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Período"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.periodoOptions,
      "state": _vm.state('periodo')
    },
    model: {
      value: _vm.form.periodo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "periodo", $$v);
      },
      expression: "form.periodo"
    }
  }), _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.errors.periodo) + " ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Rotina automática"
    }
  }, [_c('div', {
    staticClass: "form-control-plaintext text-muted"
  }, [_vm._v(" Geração entre 00:00 e 06:00. Envio às 07:00. ")])])], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Sem movimento"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.enviar_sem_movimento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "enviar_sem_movimento", $$v);
      },
      expression: "form.enviar_sem_movimento"
    }
  }, [_vm._v(" Enviar mesmo sem movimento ")])], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Assunto do e-mail"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Arquivos contábeis da competência"
    },
    model: {
      value: _vm.form.assunto_email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "assunto_email", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.assunto_email"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Mensagem do e-mail"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "2",
      "placeholder": "Segue link para download do Pacote ZIP."
    },
    model: {
      value: _vm.form.mensagem_email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mensagem_email", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.mensagem_email"
    }
  })], 1)], 1)], 1), _c('b-form-group', {
    attrs: {
      "label": "Itens para envio"
    }
  }, [_c('ItensEnvioChecklist', {
    attrs: {
      "itens": _vm.itens,
      "error": _vm.errors.itens
    },
    model: {
      value: _vm.form.itens,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "itens", $$v);
      },
      expression: "form.itens"
    }
  })], 1), _vm.spedFiscalSelecionado ? _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Perfil do SPED Fiscal"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.perfilSpedOptions,
      "state": _vm.state('perfil_sped')
    },
    model: {
      value: _vm.form.perfil_sped,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "perfil_sped", $$v);
      },
      expression: "form.perfil_sped"
    }
  }), _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.errors.perfil_sped) + " ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Perfil informado no registro 0000 do arquivo SPED. ")])], 1)], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-end mt-5"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.saving
    }
  }, [_vm.saving ? _c('span', {
    staticClass: "spinner-border spinner-border-sm mr-2"
  }) : _vm._e(), _vm._v(" Salvar configuração ")])])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };